import PropTypes from "prop-types";

import {
  FormSkeleton,
  useCustomFieldConfigs,
  useCustomFieldGroups,
} from "components/BaseForm";
import { useContact } from "hooks/useContact";
import ContactForm from "routes/contact/form/ContactForm";
import { MODEL_TYPE } from "routes/contact/form/constants";
import { FORM_MODES } from "routes/contact/form/defaults";

/** Loads a contact by id, or none, and mounts the Contact form for it. */
const ContactFormLoader = ({ id, onSaved, onCancel }) => {
  const contactQuery = useContact(id);
  const configsQuery = useCustomFieldConfigs(MODEL_TYPE);
  const groupsQuery = useCustomFieldGroups(MODEL_TYPE);

  if (contactQuery.isError || configsQuery.isError) {
    return <p>Could not load the form.</p>;
  }

  const isLoading =
    (id && !contactQuery.isFetchedAfterMount) ||
    configsQuery.isPending ||
    groupsQuery.isPending;

  if (isLoading) {
    return <FormSkeleton sections={3} className="tw:max-w-7xl" />;
  }

  return (
    <ContactForm
      mode={id ? FORM_MODES.edit : FORM_MODES.create}
      record={contactQuery.data}
      customFieldConfigs={configsQuery.data ?? []}
      customFieldGroups={groupsQuery.data ?? []}
      onSaved={onSaved}
      onCancel={onCancel}
    />
  );
};

ContactFormLoader.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onSaved: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ContactFormLoader;
